import React from 'react';
import Typography from '../../../foundations/Typography';
import { DivContainerStyled } from './styles';

export default class RecaptchaInFormBadgeComponent extends React.Component {
  render() {
    return (
      <DivContainerStyled className='safari-inflow-recaptcha-disclaimer'>
        <Typography
          component='small'
          disableBottomPadding>
          This site is protected by reCAPTCHA.
        </Typography>
      </DivContainerStyled>
    );
  }
}
